export default __webpack_public_path__ + "resources/icons/d342-1435.png";